import clsx from 'clsx';
import WarningIcon from '../../assets/icons/warning-icon.svg?react';
import React from 'react';
import TextArea from '../TextArea';
import Button from '../Button';
import { useButtonSizeSmall } from '../../utils/buttonSizes';
import ReportIcon from '../../assets/icons/report-icon.svg?react';

interface CorrectiveActionCloseProps {
  otherClasses?: string;
  formHandler: any;
  handleClose: () => void;
  isReopen?: boolean;
}

const CorrectiveActionClose: React.FC<CorrectiveActionCloseProps> = ({
  otherClasses,
  formHandler,
  handleClose,
  isReopen,
}) => {
  const correctiveActionCloseClasses = clsx(otherClasses);
  const sm = useButtonSizeSmall();
  return (
    <div
      className={correctiveActionCloseClasses}
      data-testid="corrective-action-close"
    >
      <div className="mb-12 flex w-full flex-col items-center gap-2.5 text-center">
        {isReopen ? (
          <ReportIcon className="[&>path]:fill-brand-byzantine h-12 w-12 md:h-85 md:w-85" />
        ) : (
          <WarningIcon className="h-12 w-12 md:h-85 md:w-85" />
        )}
        <h4
          className={clsx(
            'capitalize',
            isReopen ? 'text-brand-byzantine' : 'text-brand-posh-pink',
          )}
        >
          Are you sure?
        </h4>
        <p
          className={clsx(
            'font-inter-variable text-lg leading-5 font-normal',
            isReopen ? 'text-brand-byzantine' : 'text-brand-posh-pink',
          )}
        >
          {isReopen
            ? `Marking this incident as reopened will send an email to site management
          with reason of reopening.`
            : `Marking this incident as closed will send an email to site management
          with reason of closure.`}
        </p>
      </div>
      <form
        action="#"
        onSubmit={formHandler?.handleSubmit}
        className="flex w-full flex-col gap-12"
      >
        <TextArea
          name="reason"
          onBlur={formHandler?.handleBlur}
          onChange={formHandler?.handleChange}
          value={formHandler?.values?.reason}
          placeholder={
            isReopen
              ? "For e.g. This incidents poses a threat to many employee's... "
              : 'For e.g. The same incident has already been reported and is in progress...'
          }
          disabled={formHandler?.isSubmitting}
          errorMessage={
            formHandler?.touched.reason && formHandler?.errors.reason
              ? formHandler?.errors.reason
              : ''
          }
          label="Reason*"
          otherClasses={{ container: 'w-full ' }}
        />
        <div className="flex flex-col-reverse gap-3 sm:flex-row lg:gap-6">
          <Button
            variant="secondary"
            type="button"
            size={sm}
            onClick={() => handleClose()}
            otherClasses="text-brand-posh-pink hover:text-brand-posh-pink hover:border-brand-posh-pink w-full"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            loading={formHandler?.isSubmitting}
            disable={formHandler?.isSubmitting}
            size={sm}
            otherClasses={clsx(
              'w-full',
              isReopen
                ? 'bg-brand-byzantine hover:border-brand-byzantine hover:text-brand-byzantine'
                : 'bg-brand-posh-pink hover:border-brand-posh-pink hover:text-brand-posh-pink',
            )}
          >
            {isReopen ? 'Reopen Incident' : 'Close Incident'}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default CorrectiveActionClose;
